export const formatKmString = (km: number): string => {
    if (km === 0) return "0";
    return km.toLocaleString().replace(",", ".");
};
